/**
 * This file is for internal constants only.
 * It is not intended for public use and is not part of the public API
 */
import { objectFlip } from "./utils/objectFlip.js";
export var CONDITIONAL_OPERATORS = {
  "=": "eq",
  "!=": "ne",
  "<": "lt",
  ">": "gt",
  "<=": "lte",
  ">=": "gte",
  "&&": "and",
  "||": "or",
  "*": "mul",
  "/": "div",
  "+": "add",
  "-": "sub",
  "^": "pow"
};
export var RESERVED_NAMES = {
  "aspect_ratio": "ar",
  "aspectRatio": "ar",
  "current_page": "cp",
  "currentPage": "cp",
  "duration": "du",
  "face_count": "fc",
  "faceCount": "fc",
  "height": "h",
  "initial_aspect_ratio": "iar",
  "initial_height": "ih",
  "initial_width": "iw",
  "initialAspectRatio": "iar",
  "initialHeight": "ih",
  "initialWidth": "iw",
  "initial_duration": "idu",
  "initialDuration": "idu",
  "page_count": "pc",
  "page_x": "px",
  "page_y": "py",
  "pageCount": "pc",
  "pageX": "px",
  "pageY": "py",
  "tags": "tags",
  "width": "w",
  "trimmed_aspect_ratio": "tar",
  "current_public_id": "cpi",
  "initial_density": "idn",
  "page_names": "pgnames"
};
export var ACTION_TYPE_TO_CROP_MODE_MAP = {
  limitFit: 'limit',
  limitFill: 'lfill',
  minimumFit: 'mfit',
  thumbnail: 'thumb',
  limitPad: 'lpad',
  minimumPad: 'mpad'
};
export var ACTION_TYPE_TO_DELIVERY_MODE_MAP = {
  colorSpace: 'cs',
  dpr: 'dpr',
  density: 'dn',
  defaultImage: 'd',
  format: 'f',
  quality: 'q'
};
export var ACTION_TYPE_TO_EFFECT_MODE_MAP = {
  redEye: 'redeye',
  advancedRedEye: 'adv_redeye',
  oilPaint: 'oil_paint',
  unsharpMask: 'unsharp_mask',
  makeTransparent: 'make_transparent',
  generativeRestore: 'gen_restore'
};
export var ACTION_TYPE_TO_QUALITY_MODE_MAP = {
  autoBest: 'auto:best',
  autoEco: 'auto:eco',
  autoGood: 'auto:good',
  autoLow: 'auto:low',
  jpegminiHigh: 'jpegmini:1',
  jpegminiMedium: 'jpegmini:2',
  jpegminiBest: 'jpegmini:0'
};
export var ACTION_TYPE_TO_STREAMING_PROFILE_MODE_MAP = {
  fullHd: 'full_hd',
  fullHdWifi: 'full_hd_wifi',
  fullHdLean: 'full_hd_lean',
  hdLean: 'hd_lean'
};
export var CHROMA_VALUE_TO_CHROMA_MODEL_ENUM = {
  444: "CHROMA_444",
  420: "CHROMA_420"
};
export var COLOR_SPACE_MODEL_MODE_TO_COLOR_SPACE_MODE_MAP = {
  'noCmyk': 'no_cmyk',
  'keepCmyk': 'keep_cmyk',
  'tinySrgb': 'tinysrgb',
  'srgbTrueColor': 'srgb:truecolor'
};
export var ACTION_TYPE_TO_BLEND_MODE_MAP = {
  'antiRemoval': 'anti_removal'
};
export var CHROMA_MODEL_ENUM_TO_CHROMA_VALUE = objectFlip(CHROMA_VALUE_TO_CHROMA_MODEL_ENUM);
export var COLOR_SPACE_MODE_TO_COLOR_SPACE_MODEL_MODE_MAP = objectFlip(COLOR_SPACE_MODEL_MODE_TO_COLOR_SPACE_MODE_MAP);
export var CROP_MODE_TO_ACTION_TYPE_MAP = objectFlip(ACTION_TYPE_TO_CROP_MODE_MAP);
export var DELIVERY_MODE_TO_ACTION_TYPE_MAP = objectFlip(ACTION_TYPE_TO_DELIVERY_MODE_MAP);
export var EFFECT_MODE_TO_ACTION_TYPE_MAP = objectFlip(ACTION_TYPE_TO_EFFECT_MODE_MAP);
export var QUALITY_MODE_TO_ACTION_TYPE_MAP = objectFlip(ACTION_TYPE_TO_QUALITY_MODE_MAP);
export var STREAMING_PROFILE_TO_ACTION_TYPE_MAP = objectFlip(ACTION_TYPE_TO_STREAMING_PROFILE_MODE_MAP);